/* ── ML Custom Nav Drawer — Frosted Glass Scuffers-style ── */
(function () {
  var STYLE_ID = 'ml-nav-style';

  var CSS = `
    #ml-nav-dialog {
      border: none;
      padding: 0;
      background: transparent;
      max-width: 100vw;
      max-height: 100dvh;
      width: 100vw;
      height: 100dvh;
      overflow: hidden;
    }
    #ml-nav-dialog::backdrop { background: rgba(0,0,0,0.35); backdrop-filter: blur(4px); }

    #ml-nav-inner {
      position: fixed;
      top: 14px;
      left: 14px;
      right: auto;
      width: calc(100vw - 28px);
      max-width: 400px;
      max-height: calc(100dvh - 28px);
      background: rgba(255,255,255,0.28);
      backdrop-filter: blur(32px) saturate(170%);
      -webkit-backdrop-filter: blur(32px) saturate(170%);
      border-radius: 20px;
      border: 1px solid rgba(255,255,255,0.18);
      box-shadow: 0 16px 64px rgba(0,0,0,0.22), 0 2px 12px rgba(0,0,0,0.07);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 20px 22px 36px;
      display: flex;
      flex-direction: column;
    }
    #ml-nav-inner::-webkit-scrollbar { width: 0; }

    /* Header: logo left, close right */
    #ml-nav-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
    }
    #ml-nav-logo {
      height: 48px;
      width: auto;
      opacity: 0.9;
      display: block;
      filter: invert(0);
    }
    #ml-nav-close {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: rgba(0,0,0,0.08);
      cursor: pointer;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      flex-shrink: 0;
      line-height: 1;
    }
    #ml-nav-close:hover { background: rgba(0,0,0,0.14); }

    /* Nav links — plain text, no buttons, no pills */
    #ml-nav-links {
      display: flex;
      flex-direction: column;
      gap: 0;
      margin: 0;
      padding: 0;
    }
    #ml-nav-links a {
      display: block;
      font-size: clamp(2rem, 9vw, 2.8rem);
      font-weight: 900;
      letter-spacing: -0.03em;
      text-transform: uppercase;
      line-height: 1.1;
      padding: 2px 0;
      color: #000 !important;
      text-decoration: none !important;
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      transition: opacity 0.15s;
    }
    #ml-nav-links a:hover { opacity: 0.35; }

    /* Divider */
    #ml-nav-divider {
      height: 1px;
      background: rgba(0,0,0,0.09);
      margin: 18px 0 12px;
    }

    /* Best sellers label */
    #ml-best-sellers-label {
      font-size: 0.65rem;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: #000;
      margin-bottom: 10px;
    }

    /* Product cards — frosted glass */
    #ml-nav-products {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .ml-nav-product-card {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: rgba(255,255,255,0.12);
      backdrop-filter: blur(20px) saturate(150%);
      -webkit-backdrop-filter: blur(20px) saturate(150%);
      border: 1px solid rgba(255,255,255,0.55);
      border-radius: 50px;
      padding: 6px 14px 6px 6px;
      text-decoration: none !important;
      color: #000 !important;
      font-weight: 700;
      font-size: 12px;
      letter-spacing: normal;
      box-shadow: 0 1px 6px rgba(0,0,0,0.06);
      transition: transform 0.15s, background 0.15s;
      width: fit-content;
      max-width: 100%;
      text-transform: uppercase;
    }
    .ml-nav-product-card:hover {
      transform: translateY(-1px);
      background: rgba(255,255,255,0.28);
    }
    .ml-nav-product-card img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
      background: rgba(200,200,200,0.5);
    }
    .ml-nav-product-card-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ml-nav-product-card-price {
      display: none;
    }

    /* Open / close animations — mirrors cart drawer, left side */
    @keyframes mlNavIn {
      from { opacity: 0; transform: translateX(-24px) scale(0.97); }
      to   { opacity: 1; transform: translateX(0) scale(1); }
    }
    @keyframes mlNavOut {
      from { opacity: 1; transform: translateX(0) scale(1); }
      to   { opacity: 0; transform: translateX(-24px) scale(0.97); }
    }
    @keyframes mlNavBackdropIn {
      from { background: rgba(0,0,0,0); backdrop-filter: blur(0px); -webkit-backdrop-filter: blur(0px); }
      to   { background: rgba(0,0,0,0.35); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
    }
    @keyframes mlNavBackdropOut {
      from { background: rgba(0,0,0,0.35); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
      to   { background: rgba(0,0,0,0); backdrop-filter: blur(0px); -webkit-backdrop-filter: blur(0px); }
    }
    #ml-nav-dialog[open]:not(.ml-closing) #ml-nav-inner {
      animation: mlNavIn 0.5s cubic-bezier(0.4,0,0.2,1) forwards;
    }
    #ml-nav-dialog[open]:not(.ml-closing)::backdrop {
      animation: mlNavBackdropIn 0.5s ease forwards;
    }
    #ml-nav-dialog[open].ml-closing #ml-nav-inner {
      animation: mlNavOut 0.5s cubic-bezier(0.4,0,0.2,1) forwards;
    }
    #ml-nav-dialog[open].ml-closing::backdrop {
      animation: mlNavBackdropOut 0.65s ease forwards;
    }

    /* Kill all focus outlines inside the nav dialog */
    #ml-nav-dialog *:focus,
    #ml-nav-dialog *:focus-visible {
      outline: none !important;
      box-shadow: none !important;
      -webkit-tap-highlight-color: transparent !important;
    }
  `;

  var LINKS = [
    { label: 'New In',    url: '/collections/ss26-2' },
    { label: 'Shop All',  url: '/collections/all-products-smart' },
    { label: 'Hoodies',   url: '/collections/hoodies' },
    { label: 'Tartans',   url: '/collections/tartan-hidden-pocket-hoodies' },
    { label: 'Denims',    url: '/collections/denims' },
    { label: 'Shirts',    url: '/collections/shirts' },
    { label: 'Fur',       url: '/collections/fur-garments' },
    { label: 'Archive',   url: '/pages/archive' },
    { label: 'Contact',   url: '/pages/contact-us' },
  ];

  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/1019/2447/1082/t/2/assets/lion-crest-no-bg.png?v=1789760285';

  function init() {
    if (document.getElementById('ml-nav-dialog')) return;

    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    var dialog = document.createElement('dialog');
    dialog.id = 'ml-nav-dialog';

    var inner = document.createElement('div');
    inner.id = 'ml-nav-inner';

    // Header: logo + close
    var header = document.createElement('div');
    header.id = 'ml-nav-header';

    var logo = document.createElement('img');
    logo.id = 'ml-nav-logo';
    logo.src = LOGO_URL;
    logo.alt = 'More Life';
    header.appendChild(logo);

    var closeBtn = document.createElement('button');
    closeBtn.id = 'ml-nav-close';
    closeBtn.innerHTML = '&times;';
    header.appendChild(closeBtn);
    inner.appendChild(header);

    // Nav links
    var nav = document.createElement('nav');
    nav.id = 'ml-nav-links';
    LINKS.forEach(function(item) {
      var a = document.createElement('a');
      a.href = item.url;
      a.textContent = item.label;
      nav.appendChild(a);
    });
    inner.appendChild(nav);

    // Divider + label
    var divider = document.createElement('div');
    divider.id = 'ml-nav-divider';
    inner.appendChild(divider);

    var bsLabel = document.createElement('div');
    bsLabel.id = 'ml-best-sellers-label';
    bsLabel.textContent = 'Best Sellers';
    inner.appendChild(bsLabel);

    // Product cards
    var productsEl = document.createElement('div');
    productsEl.id = 'ml-nav-products';
    inner.appendChild(productsEl);

    dialog.appendChild(inner);
    document.body.appendChild(dialog);

    // Fetch best sellers
    fetch('/collections/best-sellers/products.json?limit=3')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        (data.products || []).slice(0, 3).forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src.replace(/\.jpg/, '_80x80.jpg') : '';
          var price = p.variants && p.variants[0] ? '$' + parseFloat(p.variants[0].price).toFixed(0) : '';
          var a = document.createElement('a');
          a.className = 'ml-nav-product-card';
          a.href = '/products/' + p.handle;
          a.innerHTML =
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div style="width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,0.15);flex-shrink:0"></div>') +
            '<span class="ml-nav-product-card-title">' + p.title + '</span>';
          productsEl.appendChild(a);
        });
      })
      .catch(function() {});

    var isOpen = false;

    function openNav() {
      if (isOpen) return;
      isOpen = true;
      dialog.classList.remove('ml-closing');
      dialog.showModal();
    }

    function closeNav() {
      if (!isOpen) return;
      isOpen = false;
      dialog.classList.add('ml-closing');
      setTimeout(function() {
        dialog.classList.remove('ml-closing');
        dialog.close();
        var hamburger = document.querySelector('summary.header__icon--menu, summary.header__icon--summary');
        if (hamburger) hamburger.blur();
      }, 500);
    }

    closeBtn.addEventListener('click', closeNav);
    dialog.addEventListener('click', function(e) {
      var rect = inner.getBoundingClientRect();
      var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                   e.clientY >= rect.top  && e.clientY <= rect.bottom;
      if (!inside) closeNav();
    });
    dialog.addEventListener('cancel', function(e) { e.preventDefault(); closeNav(); });
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('summary.header__icon--menu, summary.header__icon--summary');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isOpen) closeNav(); else openNav();
    }, true);
    dialog.addEventListener('wheel', function(e) { e.stopPropagation(); }, { passive: true });
    dialog.addEventListener('touchmove', function(e) { e.stopPropagation(); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Cart scroll-jump fix ── */
(function() {
  if (window._mlScrollPatched) return;
  window._mlScrollPatched = true;

  var orig = window.scrollTo.bind(window);
  var pendingScrollY = null;

  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.cart-drawer__close-button');
    if (!closeBtn) return;
    var top = document.body.style.top;
    if (top) { pendingScrollY = parseInt(top) * -1; }
  }, true);

  document.addEventListener('click', function(e) {
    var cartDialog = document.querySelector('.cart-drawer__dialog');
    if (!cartDialog || !cartDialog.open) return;
    var rect = cartDialog.getBoundingClientRect();
    var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                 e.clientY >= rect.top  && e.clientY <= rect.bottom;
    if (!inside) {
      var top = document.body.style.top;
      if (top) pendingScrollY = parseInt(top) * -1;
    }
  }, true);

  window.scrollTo = function(xOrOptions, y) {
    if (
      pendingScrollY !== null &&
      xOrOptions !== null &&
      typeof xOrOptions === 'object' &&
      xOrOptions.behavior === 'instant'
    ) {
      var target = pendingScrollY;
      pendingScrollY = null;
      orig({ top: target, behavior: 'instant' });
      return;
    }
    pendingScrollY = null;
    if (typeof xOrOptions === 'object') {
      orig(xOrOptions);
    } else {
      orig(xOrOptions, y);
    }
  };
})();

/* ── Add price to ATC button ── */
(function() {
  if (window._mlAtcPricePatched) return;
  window._mlAtcPricePatched = true;

  function getPrice() {
    var el = document.querySelector(".price");
    return el ? el.textContent.trim().split("\n")[0].trim() : "";
  }

  function updateButton() {
    var btn = document.querySelector("button[type=submit].add-to-cart-button");
    if (!btn) return;
    var price = getPrice();
    if (!price) return;
    var existing = btn.querySelector(".ml-atc-price");
    if (existing) {
      existing.textContent = price;
    } else {
      var span = document.createElement("span");
      span.className = "ml-atc-price";
      span.textContent = price;
      span.style.cssText = "color:#fff!important;font-size:15px;font-weight:500;letter-spacing:-0.01em;opacity:0.9;margin-left:auto;";
      btn.appendChild(span);
    }
  }

  updateButton();
  document.addEventListener("DOMContentLoaded", updateButton);
  window.addEventListener("load", function() { setTimeout(updateButton, 300); setTimeout(updateButton, 1000); });

  document.addEventListener("change", function(e) {
    if (e.target && (e.target.name === "id" || e.target.closest("[data-variant-picker]"))) {
      setTimeout(updateButton, 200);
    }
  });

  setTimeout(function() {
    updateButton();
    var priceEl = document.querySelector(".price");
    if (priceEl) {
      new MutationObserver(function() { setTimeout(updateButton, 50); })
        .observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }, 800);
})();


